import { IsDefined, IsInt, IsOptional, IsString } from "class-validator";

export class ChatUserDto {
    @IsDefined()
    @IsInt()
    id: number;

    @IsDefined()
    @IsString()
    userName: string;

    @IsOptional()
    @IsString()
    profileImageURL?: string;
}